import { supabase } from '@/integrations/supabase/client';

export interface GenerateLogoParams {
  name: string;
  description?: string;
  style?: string;
  industry?: string;
  primaryColor?: string;
  secondaryColor?: string;
}

export interface GenerateLogoResponse {
  success: boolean;
  image_url: string;
  replicate_prediction_id: string;
  storage_path: string;
}

export class LogoGeneratorService {
  static async generateLogo(params: GenerateLogoParams): Promise<GenerateLogoResponse> {
    const { data, error } = await supabase.functions.invoke('image-handler', {
      body: { ...params, action: 'generate-logo' }
    });

    if (error) {
      console.error('Error generating logo:', error);
      throw new Error(`Failed to generate logo: ${error.message}`);
    }

    if (!data.success) {
      throw new Error(data.error || 'Logo generation failed');
    }

    return data;
  }
}
